import { useFetchConsignmentItem } from '../api/fetchConsignmentItem'
import { useFetchConsignmentItemDocuments } from '../../consignment-item-document/api/fetchConsignmentItemDocuments'
import useSaveConsignmentItemForm from './useSaveConsignmentItemForm'
import { useFetchAdditionalReferences } from '../../additional-reference/api/fetchAdditionalReferences'

interface UseConsignmentItemParams {
  id: number | null
  consignmentId: number
  transitOperationId: number
  houseConsignmentId: number
}
function useConsignmentItem({
  id,
  consignmentId,
  transitOperationId,
  houseConsignmentId,
}: UseConsignmentItemParams) {
  const { data: consignmentItem, isFetching: isConsignmentItemLoading } = useFetchConsignmentItem(id)
  const { data: consignmentItemDocuments, isFetching: isConsignmentItemDocumentsLoading } = useFetchConsignmentItemDocuments(id)
  const { data: additionalReferences, isFetching: isAdditionalReferencesLoading } = useFetchAdditionalReferences({ parentId: id, parentType: 'consignmentItem' })
  const { saveConsignmentItemFormValues } = useSaveConsignmentItemForm({
    id,
    consignmentId,
    transitOperationId,
    houseConsignmentId,
    existingDocuments: consignmentItemDocuments ?? [],
  })

  return {
    consignmentItem,
    consignmentItemDocuments,
    additionalReferences,
    isLoading: isConsignmentItemLoading || isConsignmentItemDocumentsLoading || isAdditionalReferencesLoading,
    saveConsignmentItemFormValues,
  }
}

export default useConsignmentItem
